var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-block-evaluation" }, [
    _c(
      "ul",
      _vm._l(_vm.data, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            class: _vm.isTextWeightMedium(item),
            attrs: { "data-cy": `item-summary-${index}` },
          },
          [
            _vm._v(" " + _vm._s(item.label) + " "),
            _c(
              "span",
              {
                staticClass: "is-pulled-right",
                attrs: { "data-cy": `item-summary-${index}-value` },
              },
              [
                _vm._v(" " + _vm._s(item.value) + " "),
                item.icon
                  ? _c("b-icon", {
                      staticClass: "evaluation-icon",
                      attrs: { icon: item.icon.icon, type: item.icon.type },
                    })
                  : _vm._e(),
              ],
              1
            ),
            item.children
              ? _c(
                  "ul",
                  _vm._l(item.children, function (child, i) {
                    return _c(
                      "li",
                      {
                        key: i,
                        attrs: { "data-cy": `sub-item-summary-${index}` },
                      },
                      [
                        _vm._v(" " + _vm._s(child.label) + " "),
                        _c(
                          "span",
                          {
                            staticClass: "is-pulled-right",
                            attrs: { "data-cy": `item-summary-${index}-value` },
                          },
                          [_vm._v(" " + _vm._s(child.value) + " ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }